/* eslint-disable react-hooks/exhaustive-deps */
import Separator from "@/app/components/lib/Separator";
import { useTranslation } from "@/hooks/localization/useTranslations";
import BundleItem from "./bundle-item/BundleItem";
import { IBundleItemsDetails } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";

const BundleItems: React.FC<{
  items: IBundleItemsDetails[];
}> = ({ items }) => {
  const t = useTranslation();

  if (!items || items.length < 1) return;
  return (
    <div>
      <Separator startLabel={t.items_in_this_bundle} />
      <div className="bundle-items ">
        {items?.map((bundleItem, idx) => (
          <BundleItem
            WithoutBorder={idx === 0}
            key={`${bundleItem.id}--${idx}`}
            {...bundleItem}
          />
        ))}
      </div>
    </div>
  );
};

export default BundleItems;
